import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const role = Number(localStorage.getItem('role'));
  const token = localStorage.getItem('jwt');
  if (!token || role !== 3) {
    return <Navigate to="/login" />;
  }
  return children;
};

export default PrivateRoute;